
import Pagination from "@/components/Pagination/index.vue";
import { Vue, Component } from "vue-property-decorator";
@Component({
  components:{
    Pagination
  }
})
export default class ProductSystem extends Vue {
  private dialogVisible = false;
  private total = 100
  private listParam = {
    shippingCode: null,
    status: null,
    startDate: null,
    endDate: null,
    pageNumber: 1,
    pageSize: 8,
    dateRange: null,
    customerKeyword: "",
    saleName: "",
  };
}
